<div class="sidebar-footer col-12">
    @for(footerItems of nestedFooterItems; track footerItems){
        <ul class="row horizontal-list">
            @for(item of footerItems; track item; let index=$index){
                <li>
                    @if(item.isExternalLink){
                        <a class="col-auto option" href="{{item.externalUrl}}" target="_blank" rel="noopener" tabindex="0">
                            {{ item.title | translate}}
                        </a>
                    } @else {
                        <a class="col-auto option" [routerLink]="routerUtils.generateUrl(item.routerPath)" [ngClass]="{'option-active': router.url === item.routerPath}" tabindex="0">
                            {{ item.title | translate}}
                        </a>
                    }
                </li>
            }
        </ul>
    }
</div>
